import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

export default {
  install: function (Vue, env) {
    Raven
      .config(env.SENTRY_DSN)
      .addPlugin(RavenVue, Vue)
      .install()
  }
}



// WEBPACK FOOTER //
// ./src/plugins/sentry.js